import { Modal, ModalDialog, Input, Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { postFetch } from "../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// 프로젝트/섹션 생성·이름변경 모달
// props: open, onClose, onSuccess, mode("project"|"section"), editTarget(있으면 이름변경/없으면 생성), projectV2Id(섹션 생성 시), category(프로젝트 생성 시 - 없으면 서버에서 "headquarters" 처리)
const ProjectEditModal: React.FC<any> = (props) => {

    const [name, setName] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setName(props.editTarget ? props.editTarget.name : "");
        }
    }, [props.open, props.editTarget]);

    const submit = async () => {
        try {
            if (!name) return;

            setLoading(true);

            let url = "";
            let body: any = {};

            if (props.mode === "project") {
                if (props.editTarget) {
                    url = "/dashboard/todoist/renameProject";
                    body = { projectV2Id: props.editTarget.v2_id, name };
                } else {
                    url = "/dashboard/todoist/createProject";
                    body = { name, category: props.category };
                }
            } else {
                if (props.editTarget) {
                    url = "/dashboard/todoist/renameSection";
                    body = { sectionV2Id: props.editTarget.v2_id, name };
                } else {
                    url = "/dashboard/todoist/createSection";
                    body = { projectV2Id: props.projectV2Id, name };
                }
            }

            const result: any = await postFetch(url, body);

            if (result.message === "success") {
                toast.success("저장되었습니다.", {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    theme: "colored"
                });
                props.onSuccess();
                props.onClose();
            }

            setLoading(false);
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const title = (props.mode === "project" ? "프로젝트" : "섹션") + (props.editTarget ? " 이름 변경" : " 추가");

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "300px" }}>
                    <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: "18px" }}>
                        {title}
                    </div>
                    <Input
                        autoFocus
                        placeholder={props.mode === "project" ? "프로젝트 이름" : "섹션 이름"}
                        value={name}
                        onChange={(e: any) => setName(e.target.value)}
                        onKeyDown={(e: any) => { if (e.key === "Enter") submit(); }}
                    />
                    <div style={{ marginTop: "25px" }}>
                        <Button variant="solid" fullWidth onClick={submit} loading={loading}>
                            저장하기
                        </Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default ProjectEditModal;
